// The code in this file will load on every page of your site

import wixWindow from 'wix-window';
import {session} from 'wix-storage';

$w.onReady(function () {
	// Write your code here
});

if(!session.getItem("ogranicenje")) {
	wixWindow.openLightbox("18")
	session.setItem("ogranicenje", "yes")
	
}